import { render, staticRenderFns } from "./treatmentHistory.vue?vue&type=template&id=325cc95e&scoped=true"
import script from "./treatmentHistory.vue?vue&type=script&lang=js"
export * from "./treatmentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325cc95e",
  null
  
)

export default component.exports